import { render, staticRenderFns } from "./ItemContract.vue?vue&type=template&id=04b80c5f"
import script from "./ItemContract.vue?vue&type=script&lang=js"
export * from "./ItemContract.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports